import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APP_CONFIG } from '@app/shared/config/app.config';
import { IDtoResponse } from '@app/shared/models/dtos/response.dto';
import { IUserScope } from '@app/shared/models/scope.model';
import { ICustomSetting, IUserCustomSetting } from '@app/shared/models/settings.model';
import { map, Observable, of, tap } from 'rxjs';
import { ServiceBase } from '../base/base.service';
import { UserContext } from '../context/user.context.service';
import { PATH } from '@app/shared/types/enums/path';
import { AppContext } from '../context/app.context.service';
import { ActionEnum } from '@app/shared/types/enums/ActionEnum.enum';
import { channel } from 'version';

@Injectable({
  providedIn: 'root',
})
export class CustomerCareService extends ServiceBase {
  constructor(private readonly _http: HttpClient, private readonly _userCtxSvc: UserContext, private readonly _appCtxSvc: AppContext) {
    super(`${APP_CONFIG.serviceBaseUrl}/cx/api/customer-care/v1`);
  }

  loadUserContext(): Observable<boolean> {
    const headers = new HttpHeaders().set('monitoring_view', PATH.AUTH).set('monitoring_action', ActionEnum.READ);

    return this._http
      .get<IDtoResponse<IUserScope>>(`${this.baseUrl}/user/scopes`, {
        headers,
      })
      .pipe(
        tap((response: IDtoResponse<IUserScope>) => {
          if (response.data?.permissions) {
            this._userCtxSvc.setScopes(response.data?.permissions);
            this._userCtxSvc.setRoles(response.data?.user_roles);
          }
        }),
        map(result => result.success)
      );
  }

  /**
   *
   * @deprecated
   */
  getAllSettings(): Observable<ICustomSetting[]> {
    return this._http.get<IDtoResponse<ICustomSetting[]>>(`${this.baseUrl}/setting`).pipe(map(result => result.data || []));
  }

  /**
   *
   * @deprecated
   */
  getUserSettingsByPbEmail(pbEmail: string): Observable<IUserCustomSetting[]> {
    const headers = new HttpHeaders().set('monitoring_view', PATH.HOME).set('monitoring_action', ActionEnum.READ);

    return this._http
      .get<IDtoResponse<IUserCustomSetting[]>>(`${this.baseUrl}/setting-detail/${pbEmail}`, { headers })
      .pipe(map(result => result.data || []));
  }

  /**
   *
   * @deprecated
   */
  saveUserSettings(body: IUserCustomSetting[]): Observable<any> {
    return this._http.post<IDtoResponse<any>>(`${this.baseUrl}/setting-details`, body);
  }
}
